import { colorLog, LoggingColors } from "../../helpers/utils";

/**
 * IMPOSTA IL FAVICON DELLA PAGINA
 * @param url
 */
export const setFavicon = (url: string) => {
  // Rimuove il favicon di default
  const defaultFavicon = document.querySelector("link[rel='icon']");
  if (defaultFavicon) defaultFavicon.remove();

  const favicon = document.createElement("link");
  favicon.rel = "icon";
  favicon.href = url;
  favicon.type = url.endsWith(".svg")
    ? "image/svg+xml"
    : url.endsWith(".png")
    ? "image/png"
    : url.endsWith(".jpg")
    ? "image/jpg"
    : "image/x-icon";
};

/**
 * Formatta una chiave in kebab-case
 * @param key
 * @returns
 */
export const formatKeyToKebabCase = (key: string) => {
  return key
    .replace(/([a-z])([A-Z])/g, "$1-$2") // Aggiunge un trattino prima dei caratteri maiuscoli
    .replace(/\s+/g, "-") // Sostituisce gli spazi con trattini
    .replace(/_/g, "-") // sostituisce _ con -
    .toLowerCase(); // Converte tutto in minuscolo
};

/**
 * Carica una variabile CSS
 * @param key
 * @param value
 */
export const loadVariableToCSS = (key: string, value: string) => {
  const formattedKey = formatKeyToKebabCase(key);
  document.documentElement.style.setProperty("--" + formattedKey, value);

  // colorLog(
  //   LoggingColors.FgCyan,
  //   `Caricata variabile CSS: --${formattedKey}: ${value}`
  // );
  return formattedKey;
};
